import { useContext } from 'react'
import { Card, CardBody, Row } from 'reactstrap'
import { useContactGeneralFormSelectOptions } from '../../pages/Contacts/hooks'
import FormMainContainer from '../Common/FormMainContainer'
import FormSideContainer from '../Common/FormSideContainer'
import RecursiveForm from '../RecursiveForm'
import ContactFormGeneralContext from './ContactFormGeneralContex'

const ContactFormGeneralTab = (props) => {
    const { children, formik, inputs, subform, tabs, activeTab, handleTabChange, contactType } = props
    const { selectOptions, isPending: selectOptionsLoading } = useContactGeneralFormSelectOptions(contactType)

    return (
        <ContactFormGeneralContext.Provider
            value={{
                formik,
                inputs,
                subform,
                tabs,
                activeTab,
                handleTabChange,
                selectOptions,
                selectOptionsLoading,
            }}
        >
            <Row>{children}</Row>
        </ContactFormGeneralContext.Provider>
    )
}

export const ContactFormGeneralTabSide = () => {
    const { inputs, formik, subform, selectOptions, selectOptionsLoading } = useContext(ContactFormGeneralContext)

    return (
        <FormSideContainer>
            <Card>
                <CardBody>
                    <RecursiveForm
                        inputs={inputs?.sideForm}
                        subform={subform}
                        formik={formik}
                        selectOptions={selectOptions}
                        selectOptionsLoading={selectOptionsLoading}
                    />
                </CardBody>
            </Card>
        </FormSideContainer>
    )
}

export const ContactFormGeneralTabMain = () => {
    const { inputs, formik, subform, selectOptions, selectOptionsLoading, tabs, activeTab, handleTabChange } = useContext(ContactFormGeneralContext)

    return (
        <FormMainContainer tabs={tabs} activeTab={activeTab} handleTabChange={handleTabChange}>
            <RecursiveForm
                inputs={inputs?.mainForm}
                subform={subform}
                formik={formik}
                selectOptions={selectOptions}
                selectOptionsLoading={selectOptionsLoading}
            />
        </FormMainContainer>
    )
}

export default ContactFormGeneralTab
